import {
  Component,
  OnInit,
  ElementRef,
  HostListener,
  ChangeDetectorRef,
  PLATFORM_ID,
  Inject,
} from '@angular/core'; // Fixed import: removed unused RxJS imports (use operators pipe)
import { BehaviorSubject, Observable, Subject, Subscription, of } from 'rxjs';
import { getApps, initializeApp } from 'firebase/app';
import { environment } from '../../../environments/environment';
import { Router, NavigationEnd, Event, RouterLink } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { AuthService } from '../../services/auth.service';
import { JWTTokenService } from '../../services/jwt.token.service';
import { getAuth } from 'firebase/auth';
import { SharedService } from '../../services/shared.services';
import { HttpParams } from '@angular/common/http';
import { filter, takeUntil } from 'rxjs/operators'; // Simplified imports
import { CommonModule, isPlatformBrowser, NgIf } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonPipesModule } from '../../pipes/common-pipes.module';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    CommonPipesModule,
    NgIf,
    RouterLink,
  ],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  unreadMessages: any;
  unreadNotifications: any;
  imageURL: string | undefined;
  loggedin: boolean = false;
  isDarkEnable: boolean = false;
  showDropDown: boolean = false;
  showMenu: boolean = false;
  showSearch: boolean = false;
  notificationDropdownOpen: boolean = false;
  isServiceOpen: boolean = false;
  isListingOpen: boolean = false;
  isAreasOpen: boolean = false;
  notifications: Array<any> = [];
  totalItems: number | undefined;
  pageSizes: number = 50;
  currentPage: number = 1;
  isLoading: boolean = false;
  presentTheme$ = new BehaviorSubject<string>('dark:bg-light');
  slicedMessage: boolean = true;
  profileCompletion: number = 0;
  employeeData: any;
  employerData: any;
  private ngUnsubscribe = new Subject();
  private subscription: Subscription = new Subscription();
  isLoggedIn = false; // This drives *ngIf="!isLoggedIn" in HTML for buttons

  // Use BehaviorSubjects for reactive updates (init once, .next() for changes)
  private unreadNotificationsSubject = new BehaviorSubject<number>(0);
  private unreadMessagesSubject = new BehaviorSubject<number>(0);
  UnreadMessages$: Observable<number> =
    this.unreadMessagesSubject.asObservable();
  UnreadNotifications$: Observable<number> =
    this.unreadNotificationsSubject.asObservable();
  isBrowser: boolean = false;
  ProfileCompletion$: Observable<any> | undefined;
  FullName$: Observable<any> | undefined;
  ProfilePicture$: Observable<any> | undefined;
  PhoneNumber$: Observable<any> | undefined;
  Role$: Observable<any> | undefined;

  selectedNotification!: string;
  currentNotification: any;
  isScrolled: boolean = false;
  showEmailVerificationBanner: boolean = false;
  searchType: string = 'freelancer';
  searchValue: string = '';

  constructor(
    public sharedService: SharedService,
    private eRef: ElementRef,
    public ApiService: ApiService,
    private AuthService: AuthService,
    private router: Router,
    public jwtService: JWTTokenService,
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit() {
    this.jwtService.userProfile$.subscribe((profile) => {
      this.isLoggedIn = profile !== null;
      if (this.isLoggedIn) {
        /* ... */
      }
      this.cdr.detectChanges(); // Force update
    });

    this.subscription.add(
      this.jwtService.userProfile$.subscribe((profile) => {
        this.isLoggedIn = profile !== null;
        if (this.isLoggedIn) {
          this.updateNotifications(); // Fetch on login
          this.getNotifications();
        }
      })
    );

    // Route change handling
    this.router.events
      .pipe(
        filter(
          (event: Event): event is NavigationEnd =>
            event instanceof NavigationEnd
        ),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((event: NavigationEnd) => {
        this.onRouteChange(event);
        this.showDropDown = false;
        this.notificationDropdownOpen = false;
        this.isAuthRoute();
        this.showMenu = false; // From subscribeToRouteChanges()
      });

    // FIXED: Consolidated auth checks—rely on isLoggedIn subscription
    this.Role$ = this.AuthService.currentRole;
    this.FullName$ = this.AuthService.currentFullName;
    this.ProfilePicture$ = this.AuthService.currentPicture;
    this.PhoneNumber$ = this.AuthService.currentPhoneNumber;
    this.ProfileCompletion$ = this.AuthService.currentprofileCompletion;

    if (!getApps().length) {
      initializeApp(environment.firebaseConfig);
    }

    this.subscription.add(
      this.jwtService.userProfile$.subscribe((profile) => {
        this.isLoggedIn = profile !== null;
        if (this.isLoggedIn) {
          this.updateNotifications();
          this.getNotifications();
        }
      })
    );

    this.imageURL = this.ApiService.basePictureURL;

    if (this.isLoggedIn) {
      this.ApiService.isAuthenticatedSrc.next(true);
      this.fetchProfileData();
    }
  }

  // New helper: Fetch profile data for employee/employer
  private fetchProfileData() {
    if (this.ApiService.isEmployee()) {
      this.profileCompletion = 0;
      this.ApiService.getEmployeeProfile().subscribe(
        (res: any) => {
          this.employeeData = res;
          this.ProfileCompletion$ = of(
            res.profile_completion
          ) as Observable<number>;
          if (
            this.employeeData.profile &&
            (!this.employeeData.profile.is_email_verified_for_auth ||
              this.employeeData.profile.is_email_verified_for_auth ===
                undefined)
          ) {
            this.showEmailVerificationBanner = true;
          }
        },
        (err) => {
          console.log(err);
        }
      );
    } else if (this.ApiService.isEmployer()) {
      this.ApiService.getEmployerProfile().subscribe(
        (res) => {
          this.employerData = res;
          if (
            this.employerData.profile &&
            (!this.employerData.profile.is_email_verified_for_auth ||
              this.employerData.profile.is_email_verified_for_auth ===
                undefined)
          ) {
            this.showEmailVerificationBanner = true;
          }
        },
        (err) => {
          console.log(err);
        }
      );
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const clickedInside = this.eRef.nativeElement.contains(event.target as Node);
    if (!clickedInside && this.isServiceOpen) {
      this.isServiceOpen = false;
      this.isListingOpen = false;   // reset submenus
      this.isAreasOpen = false;     // reset submenus
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event: { target: any }) {
    if (this.eRef.nativeElement.contains(event.target)) {
      // Keep open
    } else {
      this.showDropDown = false;
      this.showMenu = false;
    }
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    let element = document.querySelector('.navbar') as HTMLElement;
    if (window.pageYOffset > element.clientHeight) {
      element.classList.add('bg-white');
      element.classList.add('bg-opacity_scrolled');
      this.isScrolled = true;
    } else {
      element.classList.remove('bg-opacity');
      element.classList.remove('text-white');
      // this.isScrolled = false;  // Uncomment if needed
    }
  }

  updateNotifications() {
    if (!this.isLoggedIn) return; // Guard: Only if logged in

    this.ApiService.getAllUnreadNotifications().subscribe(
      (res: any) => {
        // FIXED: Update existing subjects instead of reassigning
        this.unreadNotificationsSubject.next(res.count_notification);
        this.unreadMessagesSubject.next(res.count_messages);

        if (this.ApiService.isEmployee()) {
          this.ApiService.getEmployeeProfile().subscribe(
            (res: any) => {
              this.employeeData = res;
              this.ProfileCompletion$ = of(
                res.profile_completion
              ) as Observable<number>;
            },
            (err) => {
              console.log(err);
            }
          );
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  changeTheme() {
    this.presentTheme$.value === 'dark:bg-light'
      ? this.presentTheme$.next('dark:bg-black')
      : this.presentTheme$.next('dark:bg-light');
    localStorage.setItem('bg', this.presentTheme$.value);
    this.isDarkEnable = !this.isDarkEnable;
  }

  showProfileOptions() {
    this.showDropDown = !this.showDropDown;
  }

  openNotificationWindow() {
    this.notificationDropdownOpen = !this.notificationDropdownOpen;
  }

  showMenuOptions() {
    this.showMenu = !this.showMenu;
  }

  toggleSearch() {
    this.showSearch = !this.showSearch;
  }

  onRouteChange(event: NavigationEnd) {
    // Typed correctly
    this.isScrolled = false;
  }

  isAuthRoute(): boolean {
    return (
      this.router.url === '/auth/sign-up' ||
      this.router.url === '/auth/login' ||
      this.router.url === '/login'
    );
  }

  isHomeRoute(): boolean {
    return this.router.url === '/home' || this.router.url === '/';
  }

  logout() {
    this.ProfileCompletion$ = of(0) as Observable<number>;
    const auth = getAuth();
    localStorage.removeItem('GPROLE');
    localStorage.removeItem('GProToken');
    localStorage.removeItem('GPSTATE');
    localStorage.removeItem('GPFullName');
    localStorage.removeItem('GPPhoneNumber');
    localStorage.removeItem('GPPicture');
    this.ApiService.isAuthenticatedSrc.next(false);

    this.jwtService.logout();
    auth.signOut().then(
      () => {
        this.router.navigate(['/auth/login']);
      },
      (error) => {
        console.error('Sign Out Error', error);
        this.router.navigate(['/auth/login']); // Navigate anyway
      }
    );
  }

  expandNotification(notification: any) {
    this.openNotification(notification);
    this.notificationDropdownOpen = true;
    notification.showFullMessage = true;
  }

  loadMore() {
    this.currentPage++;
    this.getNotifications();
  }

  markAllAsRead() {
    this.ApiService.updateReadAllNotification().subscribe(
      (res) => {
        this.ngOnInit(); // Or just updateNotifications() for efficiency
      },
      (err) => {
        console.log(err);
      }
    );
  }

  openNotification(notification: any) {
    this.selectedNotification = notification._id;
    this.currentNotification = notification;
    if (!notification.is_read) {
      this.ApiService.updateNotification(this.currentNotification).subscribe(
        (res) => {
          this.notifications.map((x: any) => {
            if (x._id === this.currentNotification._id) {
              x.is_read = true;
            }
          });
          this.sharedService.updateData('filter');
        },
        (err) => {
          console.log(err);
        }
      );
    }
  }

  getNotifications() {
    let params = new HttpParams();
    params = params.append('page', this.currentPage.toString());
    params = params.append('limit', 25); // Fixed: Always set page/limit
    this.ApiService.getAllMyNotifications(params).subscribe(
      (res: any) => {
        this.notifications = res.data;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  isSelected(route: string): boolean {
    return this.router.url === route;
  }

  search() {
    if (this.searchType === 'freelancer') {
      this.router.navigate(['/freelancers'], {
        queryParams: { query: this.searchValue },
      });
    } else {
      this.router.navigate(['/all-jobs'], {
        queryParams: { query: this.searchValue },
      });
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe(); // FIXED: Clean up all subscriptions
    // this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
